import { Config } from '../../config'

export const symbioteConfig: Config = {
  partner: 'symbiote',
  catalog: 'partner',
  displayName: 'Symbiote',
  accentColor: '#E11282',
  host: 'seating.symbiote.com',
  extraAttributes: {
  }
}
